import LazyLoad from "vanilla-lazyload";

const Common = {
  lazyLoadInstance: null,

  init: function () {
    if (window.recaptcha) {
      Common.recaptcha();
    }
    Common.lazyload();
    Common.events();
    Common.header.init();
    Common.scroll.init();
  },

  lazyload() {
    this.lazyLoadInstance = new LazyLoad();
  },

  header: {
    el: $(".header"),

    init: function () {
      Common.header.toggle();
      Common.header.sub_menu.init();
      Common.header.mobile();
      Common.header.page_scroll();

      $(window).on("resize", function () {
        Common.header.mobile();
      });
    },

    mobile: function () {
      $(".header .qcf").css("top", "");
      $(".header__right").css("height", "");
    },

    toggle: function () {
      var windowScrollTop = $(window).scrollTop();
      // toggle main navigation mobile
      $(".toggle-menu").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("active");
        $(".header").toggleClass(
          "header--was-scrolled",
          $(".header").hasClass("header--scrolled")
        );
        if (!$(".header").hasClass("header--mobile-open"))
          windowScrollTop = $(window).scrollTop();
        $(".header").toggleClass("header--mobile-open");
        $("html").toggleClass("no-scroll");
        $("html, body").scrollTop(windowScrollTop);
      });

      // Toggle dropdown
      $(".languages__toggle").on("click", function (e) {
        e.preventDefault();
        var btn = $(this);
        btn.toggleClass("languages__toggle-open");
        btn.next().slideToggle(250);
      });
    },

    page_scroll: function () {
      // On nav click
      // Close submenu.
      Common.header.el.find(".menu-item a").on("click", function (e) {
        var btn = $(this);
        if ($(window).width() < 1200 && btn.closest(".sub-menu").length) {
          var parent = btn.closest(".menu-item-has-children").children("a");
          Common.header.sub_menu.toggle(parent, "close");
          $(".toggle-menu").click();
        }
      });
    },

    sub_menu: {
      init: function () {
        this.visibility();
        // On resize.
        $(window).on("resize", function () {
          Common.header.sub_menu.visibility();
        });

        // Submenu functionality
        Common.header.el
          .find(".menu-item__toggle-submenu")
          .on("click", function (e) {
            e.preventDefault();
            var btn = $(this);

            if (btn.parent().hasClass("open") && $(window).width() < 1200) {
              Common.header.sub_menu.toggle(btn, "close");
            } else {
              Common.header.sub_menu.toggle(btn, "open");
            }
          });
      },

      toggle: function (btn, action) {
        var parent = btn.parent();
        var siblings = parent.siblings();

        if ($(window).width() < 1200) {
          siblings.removeClass("open");
          siblings.children(".sub-menu").slideUp();

          if (action == "open") {
            parent.addClass("open");
            parent.children(".sub-menu").slideDown();
          } else if (action == "close") {
            parent.removeClass("open");
            parent.children(".sub-menu").slideUp();
          }
        }
      },

      visibility: function () {
        Common.header.el.find(".menu-item__toggle-submenu").each(function () {
          var action = null;
          var btn = $(this);

          if ($(window).width() < 1200) {
            action = "close";
          } else {
            action = "open";
          }
          Common.header.sub_menu.toggle(btn, action);
        });
      },
    },
  },

  events: function () {
    $.fn.removeClassWild = function (mask) {
      return this.removeClass(function (index, cls) {
        var re = mask.replace(/\*/g, "\\S+");
        return (cls.match(new RegExp("\\b" + re + "", "g")) || []).join(" ");
      });
    };

    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Fitvids
    if ($(".entry-content").length) {
      $(".entry-content")
        .not(".animate--disable")
        .find(
          'p, h1, h2, h3, h4, h5, h6, .video, blockquote, li, hr, .gallery, [href$=".pdf"], [href$=".doc"], [href$=".docx"], [href$=".ppt"], [href$=".pptx"], [href$=".rar"], [href$=".xls"], [href$=".xlsx"], [href$=".zip"], [href$=".jpg"], [href$=".gif"], [href$=".svg"], [href$=".jpeg"], .scrolltable'
        )
        .addClass("animate");
    }

    $(".anchor").each(function () {
      var anchor = $(this);
      $('[href="#' + anchor.attr("id") + '"]').click(function (e) {
        e.preventDefault();
        if (anchor.attr("id")) {
          $("html, body").animate(
            {
              scrollTop: anchor.offset().top,
            },
            Math.abs($(window).scrollTop() - anchor.offset().top) / 3
          );
          history.pushState("", "Anchor", "#" + anchor.attr("id"));
        }
      });
      if (window.location.hash === "#" + anchor.attr("id"))
        $("html, body").scrollTop(anchor.offset().top);
    });

    $(".page-header-rune__text").height(
      $(".page-header-rune__text span").outerHeight(true)
    );
    $(window).resize(function () {
      $(".page-header-rune__text").removeAttr("style");
      $(".page-header-rune__text").height(
        $(".page-header-rune__text span").outerHeight(true)
      );
    });
  },

  scroll: {
    sticky: false,
    topbar: false,
    last: 0,

    init: function () {
      Common.scroll.do();
      $(window).scroll(function () {
        Common.scroll.do();
      });
    },

    do: function () {
      var st = $(window).scrollTop();

      if (st > 110 && !Common.scroll.sticky) {
        Common.scroll.sticky = true;
        $(".header").addClass("header--scrolled");
      } else if (st < 110 && Common.scroll.sticky) {
        Common.scroll.sticky = false;
        $(".header").removeClass("header--scrolled");
      }

      Common.scroll.last = st;
    },
  },
};

export default Common;
